
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecocredits",
      function () {
        return require("private-next-pages/ecocredits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecocredits"])
      });
    }
  